export const LIST_SERVICE_KEY_IN_SERVICES = 'List';
export const CUSTOM_LIST_SERVICE_KEY_IN_SERVICES = 'CustomList';
export const AGGREGATION_SERVICE_KEY_IN_SERVICES = 'Aggregation';
export const CUSTOMER_LIST_ID_OPTION_KEY = 'customer_list_id';
